import moment from 'moment';

/**
 * Who added a document and when (US 9477): "Added by Anna Holm · 04 Nov 2026 14:32"
 *
 * @param {Object} file Media item with added_by ({id, name}, name null for deleted users) and added_at
 * @param {Function} t vue-i18n's $t
 * @returns {string}
 */
export function documentAdded(file, t) {
  const at = file && (file.added_at || file.created_at);
  if (!at) {
    return '';
  }
  const date = moment(String(at)).format('DD MMM YYYY HH:mm');
  if (!file.added_by) {
    return t('attachments.added_at', { date: date });
  }
  const name = file.added_by.name || t('attachments.deleted_user');
  return t('attachments.added_by', { name: name, date: date });
}
